import { Link } from "react-router-dom";

const features = [
  {
    icon: "ri-line-chart-line",
    title: "榜单实时更新",
    desc: "人气榜单每天刷新，综合阅读热度与读者口碑，热门程度一目了然。",
    color: "text-primary-600 bg-primary-100",
  },
  {
    icon: "ri-apps-2-line",
    title: "分类精准筛选",
    desc: "恋爱、奇幻、悬疑等八大题材，支持连载/完结状态筛选，快速定位想看的作品。",
    color: "text-secondary-700 bg-secondary-100",
  },
  {
    icon: "ri-rocket-line",
    title: "新番抢先发现",
    desc: "新作上架即上榜，提前发现潜力佳作，书荒时不再纠结。",
    color: "text-accent-700 bg-accent-100",
  },
  {
    icon: "ri-user-star-line",
    title: "口碑高分推荐",
    desc: "以读者真实打分为依据，高评分榜单帮你高效选书、少踩雷。",
    color: "text-primary-600 bg-primary-100",
  },
];

export default function BrandSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <p className="text-sm font-medium text-primary-600">WHY US</p>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
              为什么选韩漫YY榜
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们把「帮读者快速找到好看的韩漫」当作唯一目标。不做信息堆砌，只做一件事：
              用清晰的人气榜单、完善的分类和真实的口碑评分，让你每一次打开都能快速选到想看的作品。
            </p>
            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {features.map((f) => (
                <div key={f.title} className="rounded-lg bg-background-50 p-5">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-md ${f.color}`}>
                    <i className={`${f.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-semibold text-foreground-950">{f.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{f.desc}</p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              了解更多关于我们 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="card-lift overflow-hidden rounded-lg aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20scene%20of%20a%20young%20person%20reading%20colorful%20Korean%20comics%20on%20a%20couch%20with%20a%20warm%20lamp%2C%20warm%20coral%20and%20cream%20palette%2C%20stylized%20illustration%2C%20relaxing%20hobby%20atmosphere%2C%20high%20detail%2C%20editorial%20artwork&width=600&height=800&seq=brand-reading-01&orientation=portrait"
                alt="读者沉浸阅读韩漫"
                loading="lazy"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="card-lift mt-8 overflow-hidden rounded-lg aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20illustration%20of%20a%20bookshelf%20filled%20with%20colorful%20Korean%20comic%20volumes%20and%20genre%20labels%2C%20warm%20amber%20and%20teal%20palette%2C%20stylized%20art%2C%20organized%20cozy%20bookstore%20mood%2C%20high%20detail%2C%20editorial%20artwork&width=600&height=800&seq=brand-shelf-01&orientation=portrait"
                alt="分类整理的韩漫书架"
                loading="lazy"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}